import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { useStoreon } from "storeon/react";
import { Button } from "@material-ui/core";

import styled from "@emotion/styled";
import t from "translations";

const displayed = {};

export const ActionButton = styled(Button)({
  color: "white",
});

const CloseNotificaionButton = (key, closeSnackbar) => {
  return (
    <ActionButton
      onClick={() => {
        closeSnackbar(key);
      }}
    >
      {t.dismiss}
    </ActionButton>
  );
};

const Notifier = (_) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const { dispatch, notifications } = useStoreon("notifications");
  useEffect(
    (_) => {
      notifications.forEach((obj) => {
        const { key, variant, params, text } = obj;
        if (!displayed[key]) {
          enqueueSnackbar(text, {
            onClose: (_) => {
              dispatch("notification/removed", key);
              delete displayed[key];
            },
            key,
            variant,
            action: params?.customAction
              ? params.customAction(key, closeSnackbar)
              : CloseNotificaionButton(key, closeSnackbar),
            ...params,
          });
          displayed[obj.key] = obj;
        }
      });
    },
    [notifications, dispatch, enqueueSnackbar, closeSnackbar]
  );
  return null;
};
export default Notifier;
